import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.slice.js";
// this must be in the correct sorting order
export var stageOrder = Object.freeze(['pre-payment', 'pre-submission', 'submission', 'post-submission', 'admission', 'visa-application', 'post-decision', 'deferral', 'pre-arrival', 'arrival', 'refund', 'general']);
var numberSort = function numberSort(a, b) {
  return a === b ? 0 : a > b ? 1 : -1;
};
var getCategoryIndex = function getCategoryIndex(name) {
  var order = stageOrder.indexOf(name.toLowerCase());
  if (order < 0) return 99;
  return order;
};
var sortRequirementsList = function sortRequirementsList(requirementsList) {
  var getter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (a) {
    return a;
  };
  return requirementsList.slice().sort(function (a, b) {
    return numberSort(getCategoryIndex(getter(a)), getCategoryIndex(getter(b)));
  });
};
export default sortRequirementsList;